import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 3.36 }]],
      [RiskLevel.Medium, [{ lower: 3.36, upper: 4.11 }]],
      [RiskLevel.High, [{ lower: 4.11, upper: 20 }]],
    ]),
  ],
]);

export default referenceRange;
